if (!customElements.get('emily-shop-look')) {
  customElements.define(
    'emily-shop-look',
    class EmilyShopLook extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.hotspots = Array.from(this.querySelectorAll('.em-shop-look__hotspot'));
        this.tabs = Array.from(this.querySelectorAll('.em-shop-look__tab'));
        this.cards = Array.from(this.querySelectorAll('.em-look-card'));
        this.count = Math.min(this.hotspots.length, this.cards.length);
        if (!this.count) return;

        this.initialized = true;
        this.activeIndex = Math.min(
          Math.max(Number.parseInt(this.dataset.initialIndex, 10) || 0, 0),
          this.count - 1
        );

        this.select = (index, moveFocus = false) => {
          const nextIndex = (index + this.count) % this.count;
          this.activeIndex = nextIndex;

          this.hotspots.forEach((hotspot, hotspotIndex) => {
            const active = hotspotIndex === nextIndex;
            hotspot.classList.toggle('is-active', active);
            hotspot.setAttribute('aria-pressed', active ? 'true' : 'false');
          });

          this.cards.forEach((card, cardIndex) => {
            const active = cardIndex === nextIndex;
            card.classList.toggle('is-active', active);
            card.setAttribute('aria-hidden', active ? 'false' : 'true');
          });

          this.tabs.forEach((tab, tabIndex) => {
            const active = tabIndex === nextIndex;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
          });

          if (moveFocus && this.tabs[nextIndex]) this.tabs[nextIndex].focus();
        };

        this.onKeydown = (event) => {
          let nextIndex = this.activeIndex;
          if (event.key === 'ArrowRight') nextIndex += 1;
          else if (event.key === 'ArrowLeft') nextIndex -= 1;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = this.count - 1;
          else return;

          event.preventDefault();
          this.select(nextIndex, event.currentTarget.classList.contains('em-shop-look__tab'));
        };

        this.hotspots.forEach((hotspot, index) => {
          hotspot.addEventListener('click', () => this.select(index));
          hotspot.addEventListener('mouseenter', () => this.select(index));
          hotspot.addEventListener('focus', () => this.select(index));
          hotspot.addEventListener('keydown', this.onKeydown);
        });

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', this.onKeydown);
        });

        this.select(this.activeIndex);
      }
    }
  );
}
